<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['opinions']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'opinions'],
              sectionName: 'Opinions: ',
              required: true,
              items: this.form.opinions.map((_, i) => {
                return {
                  headerLabel: i,
                  fields: [
                    new fields.Image({
                      label: 'Zdjęcie',
                      modelPath: [this, 'form', 'opinions', i, 'image'],
                      multilingual: false
                    }),
                    new fields.Input({
                      label: 'Autor',
                      modelPath: [this, 'form', 'opinions', i, 'author'],
                      multilingual: false,
                      required: true
                    }),
                    new fields.Input({
                      label: 'Stanowisko',
                      modelPath: [this, 'form', 'opinions', i, 'position'],
                      multilingual: true,
                      required: true
                    }),
                    new fields.Input({
                      label: 'Wypowiedź',
                      modelPath: [this, 'form', 'opinions', i, 'statement'],
                      multilingual: true,
                      required: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  },
  methods: {}
}
</script>
